/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import TicketQueueIcon from 'icons/TicketQueueIcon';

const messages = defineMessages({
  title: {id: 'navigation.ticket-queue'},
});

const TicketQueueItem = () => (
  <RouteLinkItem
    iconBefore={TicketQueueIcon}
    route="midas/staff/ticket-queue"
    title={messages.title}
  />
);

export default TicketQueueItem;
